<template>
  <div>
    <div v-for="category in topologyItem" :key="category.CategoryId">
      <b-form-checkbox class="ml-3" :style="'padding-left:' + paddingLeft + 'rem'" v-model="category.Download" @change="setDownload(category, category.Download)">
        <h4>
          {{ category.DisplayName }}
          <span class="smaller float-md-right mx-2"><b-badge style="font-size: 10px">Category</b-badge></span>
        </h4>
      </b-form-checkbox>
      <product-classes
        :topologyItem="category" :paddingLeft="paddingLeft + 2" @checkParent="() => category.Download = true" />
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator'
import ProductClasses from './product-classes.vue'

@Component({
  components: {
    'product-classes': ProductClasses,
  },
})

export default class extends Mixins() {
  @Prop()
  public topologyItem!: any

  @Prop()
  public paddingLeft!: number

  public setDownload(item: any, value: boolean) {
    item.ProductClasses?.forEach((pc) => {
      pc.Download = value
      pc.ManufacturingSeries?.forEach((ms) => {
        ms.Download = value
        ms.Products?.forEach((p) => {
          p.Download = value
        })
      })
    })
  }
}
</script>
